import { render } from "./ArticlesSort.vue?vue&type=template&id=6341e672&ts=true"
import script from "./ArticlesSort.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticlesSort.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/ArticlesSort.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6341e672"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6341e672', __exports__)) {
    api.reload('6341e672', __exports__)
  }
  
  module.hot.accept("./ArticlesSort.vue?vue&type=template&id=6341e672&ts=true", () => {
    api.rerender('6341e672', render)
  })

}


export default __exports__